<template>
  <FormSection
    class="app-api-agents"
    :title="$t('APP.API_AGENTS.TITLE')"
    :description="$t('APP.API_AGENTS.GUIDE_MESSAGE')"
  >
    <CardApiError v-if="apiError" :error-text="apiError" @retry="getInfo" />
    <Card v-else :is-loading="loading">
      <div v-if="apiAgent">
        <h4 dir="ltr">{{ $t('APP.API_AGENTS.TOKEN') }}:</h4>

        <CodeBlock :content="apiAgent.token" style="margin-bottom: 1rem" />

        <AppApiAgentsRegenerateButton
          :api-agent-id="apiAgent.id"
          @regenerate="setApiAgent"
        />
        <DeleteWithConfirm
          class="app-api-agents__delete"
          :message="$t('APP.API_AGENTS.DELETE')"
          :delete-function="deleteToken"
        />
      </div>
      <AppApiAgentAddButton v-else @add="setApiAgent" />
    </Card>
  </FormSection>
</template>

<script>
import { AppApiAgents } from '@/api/api';

import AppApiAgentAddButton from './AppApiAgentAddButton';
import AppApiAgentsRegenerateButton from './AppApiAgentsRegenerateButton';
import FormSection from '@@/common/layout/FormSection';
import CardApiError from '@@/common/CardApiError';
import Card from '@@/common/Card';
import CodeBlock from '@@/common/CodeBlock';

import DeleteWithConfirm from '@@/common/action-buttons/DeleteWithConfirm';

import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';

import selection from '@/directives/selection';

export default {
  name: 'AppApiAgents',
  directives: {
    selection,
  },
  components: {
    AppApiAgentAddButton,
    AppApiAgentsRegenerateButton,
    FormSection,
    CardApiError,
    DeleteWithConfirm,
    Card,
    CodeBlock,
  },
  mixins: [packageName, packageNameWatch],
  data() {
    return {
      loading: false,
      apiAgent: null,
      apiError: null,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.loading = true;
      this.apiError = null;

      return AppApiAgents.getToken({
        packageName: this.packageName,
      })
        .then(({ apiAgent }) => {
          this.apiAgent = apiAgent;
        })
        .catch(({ message }) => {
          this.apiError = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setApiAgent(apiAgent) {
      this.apiAgent = apiAgent;
    },
    deleteToken() {
      return AppApiAgents.deleteToken({
        packageName: this.packageName,
        apiAgentId: this.apiAgent.id,
      }).then(() => {
        this.apiAgent = null;
      });
    },
  },
};
</script>

<style lang="scss">
.app-api-agents {
  &__delete {
    padding: 12px 20px;
  }
}
</style>
